export const DEFAULT_LOCALE = 'ru';

export const LOCALES = {
  ru: 'RU',
  en: 'EN',
};

const ru = {
  'Dashboard': 'Панель',
  'Cases': 'Дела',
  'People': 'Люди',
  'Businesses': 'Организации',
  'OSINT Tools': 'OSINT-инструменты',
  'Entity Network': 'Граф связей',
  'Locations': 'Локации',
  'Wireless Networks': 'Беспроводные сети',
  'Settings': 'Настройки',
  'User Management': 'Пользователи',
  'Audit Logs': 'Журнал аудита',
  'Logout': 'Выйти',
  'Advanced Search': 'Расширенный поиск',
  'Loading...': 'Загрузка...',
  'Entity Relationship Network': 'Граф связей сущностей',
  'Visualize connections between people and businesses': 'Визуализация связей между людьми и организациями',

  'Person of Interest': 'Объект интереса',
  'Client': 'Клиент',
  'Witness': 'Свидетель',
  'Victim': 'Потерпевший',
  'Suspect': 'Подозреваемый',
  'Other': 'Другое',
  'Open': 'Открыто',
  'Being Investigated': 'В расследовании',
  'Closed': 'Закрыто',
  'On Hold': 'На паузе',
  'New Lead': 'Новый лид',
  'Attempted to Engage': 'Попытка контакта',
  'Engaged': 'В контакте',
  'Qualified': 'Квалифицировано',
  'Follow Up': 'Повторный контакт',
  'Archived': 'В архиве',
  'Active': 'Активно',
  'Awaiting Response': 'Ожидает ответа',
  'Email': 'Email',
  'Phone': 'Телефон',
  'Social Media': 'Соцсети',
  'Website': 'Сайт',
  'Username': 'Имя пользователя',
  'IP Address': 'IP-адрес',
  'Vehicle': 'Транспорт',
  'Financial': 'Финансы',
  'Document ID': 'ID документа',
  'Associate': 'Связанный контакт',
  'Family': 'Семья',
  'Friend': 'Друг',
  'Enemy': 'Противник',
  'Employer/Employee': 'Работодатель/сотрудник',
  'Suspect Connection': 'Связь с подозреваемым',
  'Primary Residence': 'Основное место проживания',
  'Holiday Home': 'Дом отдыха',
  'Work': 'Работа',
  'Family Residence': 'Жилье семьи',
  'Favorite Hotel': 'Предпочитаемый отель',
  'Yacht Location': 'Локация яхты',
  'Search Engines': 'Поисковые системы',
  'People Search': 'Поиск людей',
  'Data Analysis': 'Анализ данных',
  'Geolocation': 'Геолокация',
  'Documentation': 'Документация',
  'Testing': 'Тестируется',
  'Deprecated': 'Устарело',
  'Offline': 'Недоступно',
  'Text': 'Текст',
  'Textarea': 'Многострочный текст',
  'Dropdown': 'Выпадающий список',
  'Date': 'Дата',
  'Business': 'Организация',
  'Vacation': 'Отпуск',
  'Family Visit': 'Визит к семье',
  'Medical': 'Медицина',
  'Education': 'Обучение',
  'Conference': 'Конференция',
  'Relocation': 'Переезд',
  'Transit': 'Транзит',
  'Unknown': 'Неизвестно',
  'Airplane': 'Самолет',
  'Train': 'Поезд',
  'Car': 'Автомобиль',
  'Bus': 'Автобус',
  'Ship/Cruise': 'Корабль/круиз',
  'Private Jet': 'Частный самолет',
  'Helicopter': 'Вертолет',

  'Login': 'Вход',
  'Password': 'Пароль',
  'Sign in': 'Войти',
  'Sign In': 'Войти',
  'People Management': 'Управление людьми',
  'Business Management': 'Организации',
  'Cards': 'Карточки',
  'Table': 'Таблица',
  'Card View': 'Карточки',
  'Table View': 'Таблица',
  'Add Person': 'Добавить человека',
  'Add Business': 'Добавить организацию',
  'Quick Add': 'Быстро добавить',
  'Bulk Relationships': 'Массовые связи',
  'Import CSV': 'Импорт CSV',
  'Export CSV': 'Экспорт CSV',
  'Search by name, alias, or case...': 'Поиск по имени, псевдониму или делу...',
  'Search by name, owner, or city...': 'Поиск по названию, владельцу или городу...',
  'All Cases': 'Все дела',
  'All Categories': 'Все категории',
  'All Industries': 'Все отрасли',
  'All Statuses': 'Все статусы',
  'All Time': 'Все время',
  'Last Week': 'Последняя неделя',
  'Last 2 Weeks': 'Последние 2 недели',
  'Last Month': 'Последний месяц',
  'Last Quarter': 'Последний квартал',
  'Last 6 Months': 'Последние 6 месяцев',
  'Last Year': 'Последний год',
  'Previous Year': 'Предыдущий год',
  'Older': 'Старше',
  'View Details': 'Подробнее',
  'Edit': 'Редактировать',
  'Delete': 'Удалить',
  'No people found matching your search criteria.': 'Люди по заданным критериям не найдены.',
  'No businesses found matching your search criteria.': 'Организации по заданным критериям не найдены.',
  'Try adjusting your filters or search terms.': 'Измените фильтры или поисковый запрос.',
  'First Name': 'Имя',
  'First Name *': 'Имя *',
  'Last Name': 'Фамилия',
  'Case Name': 'Название дела',
  'Name': 'Имя',
  'Category': 'Категория',
  'Status': 'Статус',
  'Case': 'Дело',
  'Connections': 'Связи',
  'Actions': 'Действия',
  'Add': 'Добавить',
  'Cancel': 'Отмена',
  'Save': 'Сохранить',
  'Close': 'Закрыть',
  'Notes': 'Заметки',

  'Basic Information': 'Основная информация',
  'Business Name *': 'Название организации *',
  'Type': 'Тип',
  'Select Type': 'Выберите тип',
  'Industry': 'Отрасль',
  'Select Industry': 'Выберите отрасль',
  'Owner': 'Владелец',
  'Organization Profile': 'Профиль организации',
  'Contacts': 'Контакты',
  'Employees': 'Сотрудники',
  'Location': 'Локация',
  'Record': 'Запись',
  'Created:': 'Создано:',
  'Updated:': 'Обновлено:',
  'No contact information': 'Контактная информация отсутствует',
  'No location specified': 'Локация не указана',
  'No Owner Selected': 'Владелец не выбран',
  'Inactive': 'Неактивно',
  'Dissolved': 'Ликвидировано',
  'Address': 'Адрес',
  'Street address': 'Улица и дом',
  'Get coordinates': 'Получить координаты',
  'City': 'Город',
  'State/Province': 'Регион/область',
  'Country': 'Страна',
  'Postal Code': 'Почтовый индекс',
  'Contact Information': 'Контактная информация',
  'Registration Details': 'Регистрационные данные',
  'Registration Number': 'Регистрационный номер',
  'Role': 'Роль',
  'Department': 'Отдел',

  'Total Networks': 'Всего сетей',
  'Unique SSIDs': 'Уникальные SSID',
  'Associated': 'Связано',
  'Encrypted': 'Зашифровано',
  'Search by SSID or BSSID...': 'Поиск по SSID или BSSID...',
  'All Types': 'Все типы',
  'All Encryption': 'Все типы шифрования',
  'Min': 'Мин.',
  'Max': 'Макс.',
  'to': 'до',
  'All People': 'Все люди',
  'All KML Files': 'Все KML-файлы',
  'Loading networks...': 'Загрузка сетей...',
  'No wireless networks found': 'Беспроводные сети не найдены',
  'Encryption': 'Шифрование',
  'Signal': 'Сигнал',
  'Person': 'Человек',

  'Search': 'Поиск',
  'Search text...': 'Текст поиска...',
  'Search in:': 'Искать в:',
  'Names': 'Имена',
  'Aliases': 'Псевдонимы',
  'Source Data': 'Данные источников',
  'Categories:': 'Категории:',
  'Status:': 'Статус:',
  'CRM Status:': 'CRM-статус:',
  'Cases:': 'Дела:',
  'Filter by:': 'Фильтр по:',
  'All Dates': 'Все даты',
  'Created Date': 'Дата создания',
  'Updated Date': 'Дата обновления',
  'From:': 'С:',
  'To:': 'По:',
  'Location contains:': 'Локация содержит:',
  'City, state, address...': 'Город, регион, адрес...',
  'Location Type:': 'Тип локации:',
  'Connected to:': 'Связан с:',
  'Person name...': 'Имя человека...',
  'Connection Type:': 'Тип связи:',
  'Min connections:': 'Мин. связей:',
  'Max connections:': 'Макс. связей:',
  'Source Data Types:': 'Типы данных:',
  'Source Data Value contains:': 'Значение содержит:',
  'Email, phone, username...': 'Email, телефон, имя пользователя...',
  'All': 'Все',
  'Search Results': 'Результаты поиска',
  'Sort by:': 'Сортировать по:',
  'Select all': 'Выбрать все',

  'Loading relationships...': 'Загрузка связей...',
  'Obsidian': 'Obsidian',
  'Classic': 'Классический',
  'Filters': 'Фильтры',
  'Debug': 'Отладка',
  'Refresh Data': 'Обновить данные',
  'Hierarchical': 'Иерархия',
  'Circular': 'Круг',
  'Grid': 'Сетка',
  'Enter fullscreen': 'На весь экран',
  'Exit fullscreen': 'Выйти из полноэкранного режима',
  'Show Isolated': 'Показывать изолированные',
  'Debug Information': 'Отладочная информация',
  'Connection Types': 'Типы связей',
  'Add Connection': 'Добавить связь',
  'Zoom In': 'Увеличить',
  'Zoom Out': 'Уменьшить',
  'Fit to View': 'По размеру окна',

  'Tools': 'Инструменты',
  'Cases Management': 'Управление делами',
  'System Health': 'Состояние системы',
  'Users': 'Пользователи',
  'Audit': 'Аудит',
  'Report': 'Отчет',
  'Generate Report': 'Создать отчет',
  'Source Intelligence': 'Данные источников',
  'Source Data Types': 'Типы данных источников',
  'Custom Fields': 'Пользовательские поля',
  'Total Connections': 'Всего связей',
  'Outgoing:': 'Исходящие:',
  'Incoming:': 'Входящие:',
};

export const translations = { ru, en: {} };

export const translate = (text, locale = DEFAULT_LOCALE) => {
  if (!text || locale === 'en') return text;
  return translations[locale]?.[text] || text;
};
